import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { Position} from '../shared/models/position';

@Injectable({
  providedIn: 'root'
})
export class PositionService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<Position[]>>{
    return this.http.get<IApiResult<Position[]>>(`${this.apiUrlProvider.url}/position`);
  }

  add(entity: Position): Observable<IApiResult<Position>>{
    return this.http.post<IApiResult<Position>>(`${this.apiUrlProvider.url}/position`, entity);
  }

  update(entity: Position): Observable<IApiResult<Position>>{
    return this.http.post<IApiResult<Position>>(`${this.apiUrlProvider.url}/position/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/position/${entityId}/delete`, null);
  }
}
